const pipe = funcs => data => {
  return funcs.reduce(
    (value, func) => func(value),
    data,
  );
};

export default pipe;
